<template>
  <el-dialog
    class="dialog-3d"
    :title="$t('3d.title')"
    width="680px"
    :visible="showDialog"
    :append-to-body="true"
    @close="$emit('close-dialog')">
      <div class="dialog-main">
        <gjw-three-viewer
          class="three-container 3d-container"
          v-if="!isBimface && ['g', 'cs'].includes(platform)"
          :show="showDialog"
          :family-type="currentType"
          :store-id="storeId"
          :core-resource-id="coreResourceId"
          :core-resource-version-id="coreResourceVersionId"
          :geometry-data="geometryData"
          :api="threeApi"
          :input-parameters="inputParameters"
        />
        <gjw-bimface-viewer
          v-else
          class="three-container view-container"
          :family-type="(currentType && currentType.name) || ''"
          :view-token="viewToken"
        />
      </div>
    </el-dialog>
</template>
<script>
import GjwThreeViewer from '@/components/lib/GjwThree'
import GjwBimfaceViewer from '@/components/lib/GjwBimfaceViewer'
export default {
  name: 'DetailThreeDialog',
  components: { GjwThreeViewer, GjwBimfaceViewer },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: ''
    },
    storeId: {
      type: [Number, String],
      default: null
    },
    coreResourceId: {
      type: [Number, String],
      default: null
    },
    coreResourceVersionId: {
      type: [Number, String],
      default: null
    },
    currentType: {
      type: Object,
      default() {
        return {}
      }
    },
    geometryData: {
      type: Array,
      default() {
        return []
      }
    },
    isBimface: {
      type: Boolean,
      default: false,
    },
    viewToken: {
      type: String,
      default: ''
    },
    threeApi: {
      type: String,
      default: ''
    },
    inputParameters: {
      type: Array,
      default() {
        return []
      }
    }
  },
}
</script>
<style lang='less' scoped>
.dialog-3d{
  /deep/.el-dialog__header{
    background-color: @theme-border-color;
    height: 32px;
    line-height: 32px;
    padding: 4px 16px;
    color: @theme-text-dark;
  }
  /deep/.el-dialog__headerbtn{
    font-size: 24px;
    top: 4px;right: 16px;
  }
  /deep/.el-dialog__close{
    color: @theme-text-dark!important;
  }
  /deep/.el-dialog__body{
    padding: 0;
    overflow: hidden;
  }
  .dialog-main{
    width: 680px;height: 448px;
  }
}
</style>
